import React from 'react';

/** Lazy ClientComputedUserKpi (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedUserKpi = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-user-kpi' */
            './ClientComputedUserKpi'
        ),
);
